import PropTypes from "prop-types";
import {TRANSACTION_STATUSES} from "./jobPaymentReducer";

export const transactionInterface = {
  transactionId: PropTypes.number, // 3
  status: PropTypes.oneOf(Object.values(TRANSACTION_STATUSES)), // "Pending"
  created: PropTypes.string, // "new Date()"
  modified: PropTypes.string, // "new Date()"
  amount: PropTypes.number, // 0.03
}
